import React, { useEffect } from 'react'
import { Container, Row } from 'react-bootstrap';
import FormSignatureData from './FormSignatureData';
import FormDataEntrySignature from '../DataEntryManagement/FormDataEntrySignature';
import FormFieldList from './FormFieldList';

const FormReport = ({
    formFields,
    totalOptionId,
    setErrorValidation,
    valueRanderFunction,
    handleNumberChange,
    handleCustomNumberChange,
    handleTextChange,
    handleCustomTextChange,
    handleDateChange,
    handleCustomDateChange,
    handleTimeChange,
    handleCustomTimeChange,
    handleTextareaChange,
    handleDropdownRadioChange,
    handleCustomDropdownRadioChange,
    handleRangeScoreChange,
    handleUploadChange,
    handleScaleChange,
    handleCheckboxChange,
    handleCustomCheckboxChange,
    convertTo24,
    setToggle,
    DBPSignatureBy,
    DBPQualityCheck,
    DBPSignatureDT,
    DBPSignatureCode,
    DVSignatureCode,
    DVQualityCheck,
    DVSignatureBy,
    DVSignatureDT,
    footer,
    enableDataEntry,
    getStudySubjectFormFieldQueryHistoryDataEntry,
    getStudySubjectFormFieldQueryNotificationDataEntry,
    getStudySubjectFormFreezeUnfreezeHistoryDataEntry,
    getStudySubjectFormFieldReviewHistoryDataEntry,
    getStudyDataEntryFieldUpdatedHistoryList,
    studyPermission,
    dataEntryFormReviewHistory,
    dataEntryFormReviewHistoryLoader,
    getStudySubjectFormReviewHistoryDataEntry,
    formId,
    setToggle6,
    emptyDataEntry,
    editField,
    handleCheckboxEditFieldChange
}) => {
    const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

    useEffect(() => {
        let hasError = false;
        formFields?.forEach(field => {
            const value = Number(valueRanderFunction(field.id)?.value);
            if (field?.manageRange === "yes") {
                if (value < Number(field?.minRange) || value > Number(field?.maxRange)) {
                    hasError = true;
                }
            }
            if (field?.manageScore === "yes") {
                if (value < Number(field?.minScore) || value > Number(field?.maxScore)) {
                    hasError = true;
                }
            }
            if (field?.manageNumberRange === "yes") {
                if (value < Number(field?.minNumber) || value > Number(field?.maxNumber)) {
                    hasError = true;
                }
            }
            if (field?.manageTimeRange === "yes") {
                const hour = valueRanderFunction(field.id)?.hour?.padStart(2, '0') || "00"
                const minute = valueRanderFunction(field.id)?.minute?.padStart(2, '0') || "00"
                const second = valueRanderFunction(field.id)?.second?.padStart(2, '0') || "00"
                const format = valueRanderFunction(field.id)?.format?.toUpperCase() || "AM"
                const use12Hour = field?.clockTimeFormat === "12";
                const inputTimeStr = use12Hour
                    ? `${hour}:${minute}:${second} ${format}`
                    : `${hour}:${minute}:${second}`;

                const minTimeStr = use12Hour
                    ? `${field?.minTime || "12:00:00"} ${field?.minAmpmType?.toUpperCase() || "AM"}`
                    : `${field?.minTime || "00:00:00"}`;

                const maxTimeStr = use12Hour
                    ? `${field?.maxTime || "11:59:59"} ${field?.maxAmpmType?.toUpperCase() || "PM"}`
                    : `${field?.maxTime || "23:59:59"}`;

                const inputDate = new Date(`1970-01-01T${use12Hour ? convertTo24(inputTimeStr) : inputTimeStr}`);
                const minDate = new Date(`1970-01-01T${use12Hour ? convertTo24(minTimeStr) : minTimeStr}`);
                const maxDate = new Date(`1970-01-01T${use12Hour ? convertTo24(maxTimeStr) : maxTimeStr}`);
                if (inputDate >= minDate || inputDate <= maxDate) {
                    hasError = true;
                }
            }
            if (field?.manageDateRange === "yes") {
                const year = valueRanderFunction(field.id)?.year
                const month = valueRanderFunction(field.id)?.month
                const day = valueRanderFunction(field.id)?.day
                const inputDate = new Date(`${year}-${month}-${day}`);
                const minDate = new Date(valueRanderFunction(field.id)?.minDate);
                const maxDate = new Date(valueRanderFunction(field.id)?.minDate);
                if (inputDate >= minDate || inputDate <= maxDate) {
                    hasError = true;
                }
            }
        });
        setErrorValidation(hasError);
    }, [formFields, valueRanderFunction]);

    return (
        <>
            <Container fluid>
                <Row>
                    {formFields?.map((field, index) => (
                        (field?.conditionalIds || [])?.every(id => totalOptionId?.includes(id)) &&
                        <FormFieldList
                            field={field}
                            index={index}
                            convertTo24={convertTo24}
                            StudyMode={StudyMode}
                            studyPermission={studyPermission}
                            valueRanderFunction={valueRanderFunction}
                            handleNumberChange={handleNumberChange}
                            handleCustomNumberChange={handleCustomNumberChange}
                            handleTextChange={handleTextChange}
                            handleCustomTextChange={handleCustomTextChange}
                            handleDateChange={handleDateChange}
                            handleCustomDateChange={handleCustomDateChange}
                            handleTimeChange={handleTimeChange}
                            handleCustomTimeChange={handleCustomTimeChange}
                            handleTextareaChange={handleTextareaChange}
                            handleDropdownRadioChange={handleDropdownRadioChange}
                            handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
                            handleRangeScoreChange={handleRangeScoreChange}
                            handleUploadChange={handleUploadChange}
                            handleScaleChange={handleScaleChange}
                            handleCheckboxChange={handleCheckboxChange}
                            handleCustomCheckboxChange={handleCustomCheckboxChange}
                            enableDataEntry={enableDataEntry}
                            getStudySubjectFormFieldQueryHistoryDataEntry={getStudySubjectFormFieldQueryHistoryDataEntry}
                            getStudySubjectFormFieldQueryNotificationDataEntry={getStudySubjectFormFieldQueryNotificationDataEntry}
                            getStudySubjectFormFreezeUnfreezeHistoryDataEntry={getStudySubjectFormFreezeUnfreezeHistoryDataEntry}
                            getStudySubjectFormFieldReviewHistoryDataEntry={getStudySubjectFormFieldReviewHistoryDataEntry}
                            getStudyDataEntryFieldUpdatedHistoryList={getStudyDataEntryFieldUpdatedHistoryList}
                            handleCheckboxEditFieldChange={handleCheckboxEditFieldChange}
                            editField={editField}
                        />
                    ))}
                    <FormSignatureData
                        setToggle={setToggle}
                        DBPSignatureBy={DBPSignatureBy}
                        DBPQualityCheck={DBPQualityCheck}
                        DBPSignatureDT={DBPSignatureDT}
                        DBPSignatureCode={DBPSignatureCode}
                        DVSignatureCode={DVSignatureCode}
                        DVQualityCheck={DVQualityCheck}
                        DVSignatureBy={DVSignatureBy}
                        DVSignatureDT={DVSignatureDT}
                        footer={footer}
                    />
                    {(studyPermission?.liveViewFormSignature || studyPermission?.liveSDVFormSignature || studyPermission?.qcViewFormSignature || studyPermission?.qcSDVFormSignature) &&
                        <FormDataEntrySignature
                            emptyDataEntry={emptyDataEntry}
                            dataEntryFormReviewHistory={dataEntryFormReviewHistory}
                            getStudySubjectFormReviewHistoryDataEntry={getStudySubjectFormReviewHistoryDataEntry}
                            formId={formId}
                            StudyMode={StudyMode}
                            setToggle6={setToggle6}
                            dataEntryFormReviewHistoryLoader={dataEntryFormReviewHistoryLoader}
                        />
                    }
                </Row>
            </Container>
        </>
    )
}

export default FormReport